<template>
    <transition name="toggleContentComponent">
        <section class="content_container" v-if="ready">
            <img class="title" src="@/assets/img/contentLibrary/content-library_title.png" />
            <img class="close_icon" src="@/assets/img/contentLibrary/close-icon.png" @click="handleClose"/>    
            <div v-show="!activeId">
            <img class="side_fade left" src="@/assets/img/contentLibrary/content-library-fade.png"/>
            <div class="scroll-button left" @click="scrollLeft" :style="!thumbPosition ? 'top:50%; left:-10px' : 'transform: rotate(180deg) translate(50%, 50%); left:8px; top:49.5%; cursor: pointer'">
                <img v-if="!thumbPosition" src="@/assets/img/contentLibrary/arrow_opaque.png"/>
                <img v-else src="@/assets/img/contentLibrary/arrow-full.png"/>
            </div>
            <div
                class="content_cards"
                ref="contentCards"
                @scroll="updateThumbPosition"
            >
                <ContentCard v-for="item in children" :key="item.id" :item="item" @open-content="handleOpen"/>
            </div>
            <div class="scroll-button right" @click="scrollRight" :style="!scrollEnd ? 'transform: rotate(180deg) translate(50%, 50%); top:49.5%; right:-29px' : '; right:-11px; top:50%; cursor: pointer'">
                <img v-if="!scrollEnd" src="@/assets/img/contentLibrary/arrow_opaque.png"/>
                <img v-else src="@/assets/img/contentLibrary/arrow-full.png"/>
            </div>
            <div class="custom-scrollbar" ref="scrollbar">
                <div
                    class="scroll-thumb"
                    :style="{ left: thumbPosition + 'px' }"
                    ref="scrollThumb"
                ></div>
            </div>
            <img class="side_fade right" src="@/assets/img/contentLibrary/content-library-fade.png"/>
            </div>
            <ContentPdf class="content" v-if="type == 'contentPDF' && activeId" :item="content" @close-component="handleBack"/>
            <ContentArticle class="content" v-if="type == 'contentArticle' && activeId" :item="content" @close-component="handleBack"/>
            <ContentVideo class="content" v-if="type == 'contentVideo' && activeId" :item="content" @close-component="handleBack"/>
        </section>
    </transition>
</template>

<script>
import ContentCard from "../contentLibrary-components/ContentCard.vue";
import ContentPdf from "../contentLibrary-components/ContentPdf.vue";
import ContentArticle from "../contentLibrary-components/ContentArticle.vue";
import ContentVideo from "../contentLibrary-components/ContentVideo.vue";
import Logo from "../../ui/Logo.vue";
export default {
    components: {
        Logo,
        ContentCard,
        ContentPdf,
        ContentArticle,
        ContentVideo

    },
    props: ["properties", "pageData", "slug", "children"],
    data() {
        return {
            ready: false,
            numberOfCards: 10,
            thumbPosition: 0,
            scrollEnd: false,
            type: "",
            activeId: 0,
            content: {}
        };
    },

    mounted() {
        this.ready = true;
        this.$nextTick(() => {
            this.updateThumbPosition();
            this.$refs.contentCards.addEventListener('wheel', this.handleWheelScroll);
        });
      
        console.log("Content Library Children:", this.children);

        this.children.forEach((element) => {
            console.log(
                "Element title:",
                element.data.title,
                " type:",
                element.type
            );
        });


    },
    beforeDestroy() {
        if (this.$refs.contentCards) {
            this.$refs.contentCards.removeEventListener('wheel', this.handleWheelScroll);
        }
    },
    methods: {
        closeComponent() {
            this.$emit("closeComponent", this.slug);
        },
        scrollLeft() {
            this.$refs.contentCards.scrollBy({
                left: -250,
                behavior: "smooth",
            });
        },
        scrollRight() {
            this.$refs.contentCards.scrollBy({ left: 250, behavior: "smooth" });
        },
        updateThumbPosition() {
            const contentCards = this.$refs.contentCards;
            const maxScrollLeft = contentCards.scrollWidth - contentCards.clientWidth;

            const scrollRatio = contentCards.scrollLeft / maxScrollLeft;
            this.thumbPosition = scrollRatio * (this.$refs.scrollbar.clientWidth - this.$refs.scrollThumb.clientWidth);

           
            this.scrollEnd = contentCards.scrollLeft < maxScrollLeft;
        },
        handleWheelScroll(event) {
            event.preventDefault();
            this.$refs.contentCards.scrollLeft += event.deltaY;
        },
        handleOpen(item) {
         this.activeId = item.id
         this.type = item.type
         this.content = item.data
            console.log("item:", this.activeId, this.type);
        },
        handleClose() {
            this.$emit("closeComponent", this.slug);
        },
        handleBack() {
            this.activeId = 0;
            this.type = "";
            this.content = {};
        }
    },
    watch: {
        '$refs.contentCards.scrollLeft': 'updateThumbPosition'
    },
    computed: {},
};
</script>

<style lang="scss" scoped>
.content_container {
    position: relative;
    width: 1306px;
    height: 816px;
    background-color: var(--light-grey);
    border: 10px solid var(--beige-grey);
    border-radius: 20px;
}

.content_cards {
    padding: 0 100px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    gap: 30px;
    width: 100%;
    height: 700px;
    overflow: hidden;
    display: flex;
    align-items: center;
}
.content {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    border-radius: 10px;
}
.close_icon {
    position: absolute;
    top: -1px;
    right: -1px;;
    cursor: pointer;
    z-index: 10;
}
.side_fade {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100px;
    height: 699px;
    pointer-events: none !important;
}
.side_fade.left {
    left: 50px;
    transform: rotate(180deg) translate(50%, 50%); 
    z-index: 1;
}
.side_fade.right {
    right: 0;
    z-index: 0;
}
.custom-scrollbar {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 8px;
    width: 1100px;
    background-color: #70707034;
    border-radius: 4px;
}

.title {
    position: absolute;
    top: -1px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
}

.scroll-thumb {
    position: absolute;
    top: 0;
    height: 100%;
    width: 200px; /* Adjust width as needed */
    background-color: var(--dark-green);
    border-radius: 4px;
}

.scroll-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    z-index: 3;
}

.scroll-button.left {
}

.scroll-button.right {
}
</style>
